import type { ReactNode } from "react";
import { IconButton } from "@mui/material";
import { closeSnackbar, SnackbarProvider } from "notistack";
import type { SnackbarKey, SnackbarProviderProps } from "notistack";
import CloseIcon from "@mui/icons-material/Close";

function closeSnackbarAction(snackbarId: SnackbarKey): ReactNode {
  return (
    <IconButton
      color="inherit"
      onClick={() => {
        closeSnackbar(snackbarId);
      }}>
      <CloseIcon fontSize="small" />
    </IconButton>
  );
}

interface SdeappsSnackbarProviderType extends SnackbarProviderProps {}

export function SdeappsSnackbarProvider({
  maxSnack = 3,
  autoHideDuration = 3000,
  ...props
}: SdeappsSnackbarProviderType): ReactNode {
  return (
    <SnackbarProvider
      maxSnack={maxSnack}
      autoHideDuration={autoHideDuration}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      preventDuplicate
      action={closeSnackbarAction}
      {...props}
    />
  );
}
